import { ArrayUtil, getThemeColor, HorizontalAlignment, LicenseSettings, VerticalAlignment } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { ComponentFactory, Image, Label, Panel, Toast } from "@mcleod/components";
import { CommonDialogs } from "./CommonDialogs";

export class TempLicensingToast {
    static display() {
        const tempRevokedModules = LicenseSettings.getSingleton().getTempRevokedModules();
        if (!ArrayUtil.isEmptyArray(tempRevokedModules)) {
            const toastPanel = this.buildToastPanel(tempRevokedModules);
            Toast.showToast(toastPanel);
        }
    }

    private static buildToastPanel(tempRevokedModules: string[]): Panel {
        const outerPanel = new Panel({ wrap: false });
            outerPanel.add(new Image({
                name: ImageName.circleConfirmFilled,
                themeKey: "toast.success.image",
                rowBreak: false
            }));
            const labelTitle = new Label({
                text: "Temporary Licensing In Effect",
                themeKey: "toast.success.titleLabel",
                rowBreak: true
            });
            const labelText =
                `${tempRevokedModules.length} module${tempRevokedModules.length > 1 ? "s have" : " has"} been revoked`;
            const labelRevokedMessages = new Label({
                onClick: () => this.displayRevokedModulesDialog(tempRevokedModules),
                text: labelText,
                themeKey: "toast.success.messageLabel"
            });
            labelRevokedMessages.style.textDecoration = "underline";
            labelRevokedMessages.style.textDecorationColor = getThemeColor("primary.reverse");
            const messagePanel = new Panel({
                align: HorizontalAlignment.LEFT,
                components: [ labelTitle, labelRevokedMessages ],
                margin: 0,
                padding: 0,
                rowBreak: false,
                verticalAlign: VerticalAlignment.CENTER
            });
            outerPanel.add(messagePanel);
            return outerPanel;
    }

    private static displayRevokedModulesDialog(tempRevokedModules: string[]) {
        const panel = Panel.createNoMarginNoPaddingPanel({
            maxHeight: 500,
            scrollY: true
        });
        panel.add(new Label({
            marginBottom: 8,
            text: "The following modules have been temporarily revoked:"
        }));
        const labelProps = tempRevokedModules.map(revokedModule => {
            return {
                marginLeft: 16,
                text: revokedModule
            };
        });
        panel.add(...ComponentFactory.createBulletedList(labelProps));
        CommonDialogs.showDialog(panel, { title: "Revoked Modules" });
    }
}
